"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var spx = function (value) {
    return "".concat(value, "px");
};
exports.default = spx;
//# sourceMappingURL=spxFixedResolver.js.map